import { RowData } from '../../../../../../../../../../../../baseComponents/TwinTable/types'
import { SetEditDeleteModalTy } from '../../../../../../../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../../../../../../../utils/hooks/useTwinTranslation'
import ModalSmallFilled from '../../../../../../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { useCallback } from 'react'
import twinFetchPost from '../../../../../../../../../../../../utils/globals/data'
import { changeErrorMessage } from '../../../../../../../../../../../../utils/reducers/reduxDispatch'
import useIsLoading from '../../../../../../../../../../../../utils/hooks/useIsLoading'

interface ModalProcessSellTicketRefundProps extends ModalProcessSellTicketRefundLogicProps {
}

const ModalProcessSellTicketRefund: React.FC<ModalProcessSellTicketRefundProps> = ({ setOpenModal, ...rest}) => {
    const { t } = useTwinTranslation()
    const { handleOnAccept, loading } = useModalProcessSellTicketRefundLogic({ setOpenModal, ...rest })
    return (
        <ModalSmallFilled opened={true} setOpened={() => { }} onClickOut={false} onAccept={handleOnAccept} onCancel={() => setOpenModal(null)} translations={{
            title: t('sureProcessSellTicketRefund', '¿Seguro que quieres procesar esta devolución?'),
            subtitle: t('creatingRefundFromSelectedProducts', 'Se creará una devolución con los productos seleccionados'),
            buttonAccept: t('accept', 'Aceptar')
        }} loading={loading} />
    )
}

interface ModalProcessSellTicketRefundLogicProps {
    allRowData?: RowData
    setOpenModal: SetEditDeleteModalTy
    url: string
}

const useModalProcessSellTicketRefundLogic = ({ allRowData, url, setOpenModal }: ModalProcessSellTicketRefundLogicProps) => {
    const { startLoading, endLoading, loading } = useIsLoading()
    const { t } = useTwinTranslation()
    const notRefundDate = t('notSellTicketRefundDate', 'El ticket no está en plazo de devolución')

    const handleOnAccept = useCallback(async () => {
        startLoading?.()
        const res = await twinFetchPost(url, { ...allRowData?.values, WarehouseId: allRowData?.WarehouseId, WorkingCenterId: allRowData?.WorkingCenterId })
        const responseJSON = await res.json()
        if (res.status === 200) {
            const myHeaderData = { ...responseJSON, Customer: allRowData?.Customer }
            setOpenModal({ type: 'delete', allRowData: { ...allRowData?.values, CurrencyId: allRowData?.CurrencyId, myTotalPayments: allRowData?.myTotalPayments, headerData: myHeaderData, OrderId: responseJSON.id, WarehouseId: allRowData?.WarehouseId, WorkingCenterId: allRowData?.WorkingCenterId } })
        } else {
            if (responseJSON.errors[0].msg === 'Cannot refund because of date') {
                changeErrorMessage(notRefundDate)
            } else {
                changeErrorMessage(responseJSON.errors[0].msg)
            }
        }
        endLoading?.()
    }, [allRowData, url, setOpenModal, startLoading, endLoading, notRefundDate])
    return { handleOnAccept, loading }
}

export default ModalProcessSellTicketRefund